import { EPhoneValidationActionTypes } from '../../actions/phoneValidationCode';
import { IPhoneConfirmationState } from '../../types/phoneConfirmation';
import { TReduxActions } from '../../types/redux';

const initialState: IPhoneConfirmationState = {
  status: 'initial',
  secondsToRetry: 0,
};

export const phoneConfirmationReducer = (
  state: IPhoneConfirmationState = initialState,
  action: TReduxActions,
): IPhoneConfirmationState => {
  switch (action.type) {
    case EPhoneValidationActionTypes.SetSubmitting:
      return {
        ...state,
        status: 'pending',
        error: undefined,
        secondsToRetry: 0,
      };

    case EPhoneValidationActionTypes.SetSuccess:
      return {
        ...state,
        status: 'fulfilled',
        secondsToRetry: action.payload?.secondsToRetry || 0,
      };

    case EPhoneValidationActionTypes.SetFailure:
      return {
        ...state,
        status: 'rejected',
        secondsToRetry: action.payload?.secondsToRetry || 0,
      };

    case EPhoneValidationActionTypes.SetError:
      return {
        ...state,
        error: action.payload?.error,
        phoneError: action.payload?.phoneError,
        timeError: action.payload?.timeError,
        secondsToRetry: action.payload?.secondsToRetry || state.secondsToRetry,
      };

    default:
      return state;
  }
};
